export const LEGACY_VOTER_ID = 'legacy-initial-score';
export function normalizeItem(item) {
    const votes = item.votes ?? {};
    const hasAnyScore = Object.values(item.scores ?? {}).some((v) => v != null);
    const hasAnyVote = Object.keys(votes).length > 0;
    if (hasAnyScore && !hasAnyVote) {
        const legacy = {
            voter: { id: LEGACY_VOTER_ID, displayName: 'Initial score' },
            scores: item.scores,
            confidence: item.confidence,
            at: item.updatedAt,
        };
        return { ...item, votes: { [LEGACY_VOTER_ID]: legacy } };
    }
    return { ...item, votes };
}
